import Vue from 'vue';

/**
 * This uses template that is included in script tag
 **/

Vue.component('the-sidebar-layout', {
  template: '#js-layout-sidebar-template',
  props: ['sidebar-title'],
  computed: {
    hasSidebarTitle() {
      return this.$slots['sidebar-title'];
    }
  }
});
